import React from "react";

const GatsbyHead = ({ title, description, canonicalLink, meta = [] }) => {
  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonicalLink && <link rel="canonical" href={canonicalLink} />}

      {/* Social Media Metadata */}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:title" content={title} />
      {description && (
        <meta property="twitter:description" content={description} />
      )}

      {/* Dynamic Meta Tags */}
      {meta?.map((tag, i) => {
        // Check if 'name' or 'property' exists
        if (tag.name) {
          return <meta key={i} name={tag.name} content={tag.content} />;
        } else if (tag.property) {
          return <meta key={i} property={tag.property} content={tag.content} />;
        }
        return null;
      })}
    </>
  );
};

export default GatsbyHead;
